import type { ReactNode } from "react";
import ProfilePicture from "./Profile/ProfilePicture";

interface AppDropdownProps {
  id: string;
  imgSrc?: string | null | undefined;
  icon?: string | undefined;
  name?: string | undefined;
  children: ReactNode;
}

export default function AppDropdown({ id, imgSrc, icon, name, children }: AppDropdownProps) {
  return (
    <div className="dropdown">
      <button
        type="button"
        className="sb-header__user btn d-flex align-items-center border-0"
        id={id}
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {icon && <i className={icon}></i>}
        {imgSrc && <ProfilePicture width={36} height={36} initialsFrom={name} />}
        {name && <span className="sb-header__user-name text-truncate">{name}</span>}
        <i className="fas fa-chevron-down sb-header__user-chevron" aria-hidden="true" />
      </button>
      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby={id} style={{ minWidth: '250px' }}>
        {children}
      </ul>
    </div>
  )
}
